/**
 * CartellaApprofondimentoView view component.
 * @module components/View/CartellaApprofondimentoView
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';
import {
  PageHeader,
  SkipToMainContent,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import BandoApprofondimenti from 'design-comuni-plone-theme/components/ItaliaTheme/View/BandoView/BandoApprofondimenti';

import './cartella_approfondimento.scss';
/**
 * CartellaApprofondimentoView view component class.
 * @function CartellaApprofondimentoView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const CartellaApprofondimentoView = ({ content }) => {
  const dispatch = useDispatch();

  const parent = useSelector(
    (state) => state.content?.subrequests['parent']?.data,
  );
  useEffect(() => {
    if (content?.parent?.['@id']) {
      if (content.parent['@id'] !== parent?.['@id']) {
        dispatch(
          getContent(flattenToAppURL(content.parent['@id']), null, 'parent'),
        );
      }
    }
  }, [content]);

  return (
    <>
      <div className="container px-4 my-4 bando-view cartella-approfondimento-view">
        <SkipToMainContent />
        <PageHeader
          content={content}
          readingtime={null}
          showreadingtime={false}
          imageinheader={!!content.image}
          imageinheader_field={'image'}
          showdates={false}
          showtassonomiaargomenti={false}
        />

        <div className="row row-column-border border-light">
          <section
            className="col-lg-12 it-page-sections-container"
            id="main-content-section"
          >
            {parent && (
              <BandoApprofondimenti
                content={{
                  ...parent,
                  approfondimento: parent.approfondimento.filter(
                    (a) => a.url === content['@id'],
                  ),
                }}
              />
            )}
          </section>
        </div>
      </div>
    </>
  );
};

CartellaApprofondimentoView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default CartellaApprofondimentoView;
